import Step from './StepPrototyping'

export default Step
